var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-single" }, [
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附件信息")]),
      _vm._v(" "),
      _vm.edit
        ? _c(
            "span",
            {
              staticClass: "input-tip error",
              staticStyle: { "font-size": "12px" }
            },
            [_vm._v("提示:最多上传5个附件，每个附件大小不可超过5M")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-value" },
      [
        _vm.edit
          ? _c("swb-file-upload", {
              attrs: {
                fileGroup: "image-goods",
                onBeforeUpload: _vm.onBeforeUpload,
                onProgress: _vm.onProgress,
                onDone: _vm.onUploadDone,
                multipleFile: false
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.fileList.length > 0
          ? _c(
              "ul",
              { staticClass: "file-area clearfix" },
              _vm._l(_vm.fileList, function(file, index) {
                return _c(
                  "li",
                  { staticClass: "file-content fl clearfix" },
                  [
                    _c("swb-file-item", {
                      attrs: {
                        trackKey: index,
                        fileName: file.fileName,
                        fileUuid: file.fileUuid,
                        fileBrowseUrl: file.fileBrowseUrl,
                        fileDownloadUrl: file.fileDownLoadUrl,
                        fileMd5: file.fileMd5,
                        deletable: _vm.edit,
                        onDelete: _vm.deleteFile
                      }
                    })
                  ],
                  1
                )
              })
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.edit && _vm.fileList.length <= 0
          ? _c(
              "div",
              {
                staticClass: "font14 align-center font-gray2",
                staticStyle: { "margin-top": "20px" }
              },
              [_vm._v("无附件信息...")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1332df56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1332df56","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsRecvFileList.vue
// module id = 2681
// module chunks = 0